// Build proxied Skysight asset URLs. Mirrors services/api.js: in production
// REACT_APP_API_BASE is empty and a Vercel rewrite forwards /api/* to the
// Worker; in dev it is the Worker origin (e.g. http://localhost:8787).
const API_BASE = (process.env.REACT_APP_API_BASE || '').replace(/\/+$/, '');

export const tileTemplate = ({ base = API_BASE, region, date, time, param }) =>
  `${base}/api/forecast/tiles/${region}/${date}/${time}/${param}/{z}/{x}/{y}`;

// MapLibre appends `.json`/`.png`/`@2x.json`/`@2x.png` to the sprite base.
export const spriteUrl = (base = API_BASE) => `${base}/api/forecast/sprite/sprite`;

// MapLibre substitutes {range} and {fontstack}; the Worker forwards the
// fontstack query verbatim to maps.skysight.io.
export const glyphsUrl = (base = API_BASE) =>
  `${base}/api/forecast/fonts/{range}.pbf?{fontstack}`;
